import {Component, ViewChild} from '@angular/core';
import {MatDataSourceGeneric} from "@Services/base/daoService";
import {SnackBarToastyService} from "@Common/widgets/general/snack-bar";
import {MatDialog} from "@angular/material/dialog";
import {CategorieService} from "../../../../../services/formulaire/categorie.service";
import {CategorieDemat} from "../../../models/formdemat.model";
import {ActionDataTable, ColumnDataTable, DataTableComponent} from "@Common/widgets/general/data-table";
import {DialogData, DialogValidationComponent} from "@Common/widgets/general/dialog-validation";
import {ModalCategorieComponent} from "./cat-modal/modal-categorie/modal-categorie.component";
import {noop, of} from "rxjs";
import {switchMap} from "rxjs/operators";
import {SubSink} from "@Common/core/utils/subsink";
import {environment} from "@Env/environment";

@Component({
  selector: 'app-form-categorie',
  templateUrl: './form-categorie.component.html',
  styleUrls: ['./form-categorie.component.scss']
})
export class FormCategorieComponent {
  subSink = new SubSink();
  dsItems: MatDataSourceGeneric<CategorieDemat> = new MatDataSourceGeneric<CategorieDemat>();
  constructor(
              private snackSvc: SnackBarToastyService,
              private catSvc: CategorieService,
              public dialog: MatDialog
  ) {
    this.dsItems.daoService = catSvc;
  }
  @ViewChild(DataTableComponent, { static: true }) dataTable: DataTableComponent;
  extraParams: Map<string, string> = new Map<string, string>();
  columns: ColumnDataTable[] = [
    {
      columnDef: 'name',
      header: 'Catégorie',
      display: (cat: CategorieDemat) => cat.name,
      sort: true,
      flex: 20,
      sortField: 'name'
    },
    {
      columnDef: 'description',
      header: 'Description',
      display: (cat: CategorieDemat) => cat?.description,
      sort: false
    },
    {
      columnDef: 'active',
      header: 'Active',
      display: (cat: CategorieDemat) => cat.active ? 'Oui' : 'Non',
      sort: true,
      sortField: 'active'
    }
  ];

  actions: ActionDataTable[] = [
    {
      label: 'Visualiser',
      tooltip: 'Visualiser cette catégorie',
      icon: 'visibility',
      click: (cat: CategorieDemat) => this._view(cat),
      iconcolor: 'accent',
    },
    {
      label: 'Modifier',
      tooltip: 'Modifier cette catégorie',
      icon: 'edit',
      click: (cat: CategorieDemat) => this._update(cat),
      iconcolor: 'accent',
    },
    {
      label: 'Supprimer',
      tooltip: 'Supprimer cette catégorie',
      icon: 'delete',
      click: (cat: CategorieDemat) => this._delete(cat),
      iconcolor: 'warn',
    },
  ];

  private _view(cat: CategorieDemat) {
    const data = {
      cat: cat,
      mode: 'view',
      title: `Visualisation de la catégorie`,
      buttonText: { ok: 'Fermer' }
    };

    this._openModal(data).subscribe();
  }

  addCategorie() {
    const data = {
      cat: null,
      mode: 'create',
      title: `Ajout de catégorie`,
      buttonText: { ok: 'Sauvegarder' }
    };

    this.subSink.sink = this._openModal(data).pipe(
      switchMap((updatedCat: CategorieDemat) =>
        updatedCat ? this.catSvc.updateOrcreate(updatedCat) : of(null)
      )
    ).subscribe(
      (res) => res ? this._reload() : noop()
    );
  }

  private _update(cat: CategorieDemat) {
    const data = {
      cat: cat,
      mode: 'update',
      title: `Modification de la catégorie`,
      buttonText: { ok: 'Mettre à jour' }
    };

    this.subSink.sink = this._openModal(data).pipe(
      switchMap((updatedCat: CategorieDemat) =>
        updatedCat ? this.catSvc.updateOrcreate(updatedCat) : of(null)
      )
    ).subscribe(
      (res) => res ? this._reload() : noop()
    );
  }

  private _delete(cat: CategorieDemat) {
    const data = new DialogData();
    data.title = ``;
    data.message = 'Suppression de la categorie';
    const dialogRef = this.dialog.open(DialogValidationComponent, {data: data});
    dialogRef.updatePosition({top: '50px'});
    dialogRef.afterClosed().subscribe(
      result => {
        if (result) {
          this.catSvc.delete(cat).subscribe(data => this._reload());
        }
      }
    );
  }

  private _openModal(data: any) {
    const dialogRef = this.dialog.open(ModalCategorieComponent, {data: data,});
    dialogRef.updateSize('600px');
    dialogRef.updatePosition({top: '50px'});
    return dialogRef.afterClosed();
  }

  private _reload() {
    this.dataTable.reload();
  }
}

